module.exports = __webpack_public_path__ + "img/google.b211fe46.svg";